module.exports = __webpack_public_path__ + "img/1.365aa691.png";